import { PaycodeAttemptActions, EntityActions } from '../actions/consts';
import { PaycodeAttempt } from '../models/paycodeattempt';


type PaycodeAttemptUIState = {
  currentList: [],
  loading: false,
  errorMessage: string,
  currentPage: number,
};

type PaycodeAttemptState = {
  entities: {},
  ui: PaycodeAttemptUIState,
};

const defaultState: PaycodeAttemptState = {
  entities: {},
  ui: {
    currentList: [],
    currentPage: 0,
    loading: false,
    errorMessage: '',
    currentPage: 0,
  }
};

export function paycodeAttempts(
  state: PaycodeAttemptState = defaultState, action) {
  switch (action.type) {
    case EntityActions.ADD_ENTITIES:
      return {
        ...state,
        entities: {
          ...state.entities,
          ...action.entities.paycodes,
        }
      };
    case PaycodeAttemptActions.LOAD_REQUEST:
      return {
        ...state,
        ui: {
          ...state.ui,
          loading: true,
          errorMessage: '',
        }
      };
    case PaycodeAttemptActions.LOAD_SUCCESS:
      return {
        ...state,
        ui: {
          ...state.ui,
          loading: false,
          errorMessage: '',
        }
      };
    case PaycodeAttemptActions.LOAD_ERROR:
      return {
        ...state,
        ui: {
          ...state.ui,
          loading: false,
          errorMessage: action.error.errorMessage,
        }
      };
    case PaycodeAttemptActions.LOAD_LIST_SUCCESS:
      return {
        ...state,
        ui: {
          ...state.ui,
          loading: false,
          errorMessage: '',
          currentList: action.result,
        }
      };
    case PaycodeAttemptActions.SET_CURRENT_PAGE:
      return {
        ...state,
        ui: {
          ...state.ui,
          currentPage: action.currentPage,
        }
      };
    default:
      return state;
  }
}
